import { NgModule } from '@angular/core';
import { LegalRoutingModule } from '@app/_v2/legal/legal-routing.module';
import { LegalComponentsModule } from '@app/_v2/legal/legal-components.module';
import { LegalComponent } from '@app/_v2/legal/legal.component';

@NgModule({
  imports: [LegalComponentsModule, LegalRoutingModule],
  declarations: [LegalComponent],
  providers: [],
})
export class LegalModule {}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/legal/legal.module.ts